import { TaskCategory } from '../types';

/**
 * プリセットタスクテンプレートの型定義
 */
export interface PresetTaskTemplate {
  templateId: string;
  name: string;
  description?: string;
  category: TaskCategory;
  recommendedAssignee: '新郎' | '新婦' | '二人';
  dueDateOffset: {
    unit: 'months' | 'days';
    value: number; // 挙式日より前なら負数
  };
  priority: string;
  estimatedHours?: number;
  notes?: string;
  order: number;
  isActive: boolean;
}

/**
 * 標準的な結婚式準備タスクのプリセットテンプレート
 * 設計書・要件定義書に基づく定義
 */
export const PRESET_TASK_TEMPLATES: PresetTaskTemplate[] = [
  // 情報収集・計画（挙式12ヶ月前～）
  {
    templateId: 'preset-001',
    name: '結婚式のイメージ・コンセプト固め',
    description: 'どんな結婚式にしたいか、テーマカラー、雰囲気などを話し合う',
    category: '情報収集・計画',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -12 },
    priority: '高',
    estimatedHours: 2,
    notes: '結婚式全体の方向性を決める重要なタスクです',
    order: 1,
    isActive: true
  },
  {
    templateId: 'preset-002',
    name: '両親へ結婚報告・挨拶',
    description: 'それぞれの両親に結婚の報告をし、挨拶の日程調整を行う',
    category: '情報収集・計画',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -12 },
    priority: '高',
    estimatedHours: 1,
    notes: 'それぞれの両親に報告。挨拶の日程調整。',
    order: 2,
    isActive: true
  },
  {
    templateId: 'preset-003',
    name: '予算の大枠決定と貯蓄計画',
    description: '自己資金、親からの援助などを考慮し、総予算と項目別予算を検討',
    category: '情報収集・計画',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -11 },
    priority: '高',
    estimatedHours: 3,
    notes: '自己資金、親からの援助などを考慮し、総予算と項目別予算を検討。',
    order: 3,
    isActive: true
  },
  {
    templateId: 'preset-004',
    name: '招待客リストアップ（仮）',
    description: '呼びたい人をリストアップ。新郎側・新婦側それぞれ',
    category: '情報収集・計画',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -10 },
    priority: '中',
    estimatedHours: 2,
    notes: '呼びたい人をリストアップ。新郎側・新婦側それぞれ。',
    order: 4,
    isActive: true
  },
  {
    templateId: 'preset-005',
    name: 'ブライダルフェア参加・情報収集',
    description: '気になる式場のフェアに参加し、情報収集',
    category: '情報収集・計画',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -11 },
    priority: '中',
    estimatedHours: 4,
    notes: '気になる式場のフェアに参加し、情報収集。',
    order: 5,
    isActive: true
  },

  // 式場・会場関連（挙式10ヶ月前～）
  {
    templateId: 'preset-006',
    name: '式場見学・候補絞り込み',
    description: '3-5箇所程度に見学に行き、比較検討',
    category: '式場・会場',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -10 },
    priority: '高',
    estimatedHours: 8,
    notes: '3-5箇所程度に見学に行き、比較検討。',
    order: 6,
    isActive: true
  },
  {
    templateId: 'preset-007',
    name: '式場決定・契約',
    description: '契約内容（キャンセル規定など）をしっかり確認',
    category: '式場・会場',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -9 },
    priority: '最高',
    estimatedHours: 2,
    notes: '契約内容（キャンセル規定など）をしっかり確認。',
    order: 7,
    isActive: true
  },
  {
    templateId: 'preset-008',
    name: '第1回打ち合わせ（式場プランナーと）',
    description: '今後のスケジュール、準備の流れなどを確認',
    category: '式場・会場',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -6 },
    priority: '高',
    estimatedHours: 2,
    notes: '今後のスケジュール、準備の流れなどを確認。',
    order: 8,
    isActive: true
  },

  // 衣装・美容関連（挙式8ヶ月前～）
  {
    templateId: 'preset-009',
    name: 'ドレス・タキシード試着・検討',
    description: 'ドレスショップやタキシードレンタル店で試着',
    category: '衣装・美容',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -8 },
    priority: '高',
    estimatedHours: 6,
    notes: 'ドレスショップやタキシードレンタル店で試着。',
    order: 9,
    isActive: true
  },
  {
    templateId: 'preset-010',
    name: '衣装決定・レンタル契約',
    description: 'ドレス・タキシードの最終決定と契約',
    category: '衣装・美容',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -6 },
    priority: '高',
    estimatedHours: 2,
    notes: 'ドレス・タキシードの最終決定と契約。',
    order: 10,
    isActive: true
  },
  {
    templateId: 'preset-011',
    name: 'ヘアメイク・エステ検討',
    description: 'ヘアメイクリハーサルやエステプランの検討',
    category: '衣装・美容',
    recommendedAssignee: '新婦',
    dueDateOffset: { unit: 'months', value: -4 },
    priority: '中',
    estimatedHours: 3,
    notes: 'ヘアメイクリハーサルやエステプランの検討。',
    order: 11,
    isActive: true
  },

  // 招待状・ペーパーアイテム関連（挙式4ヶ月前～）
  {
    templateId: 'preset-012',
    name: '招待状のデザイン・文面検討',
    description: '招待状のデザインと文面を検討し、発注準備',
    category: '招待状・ペーパーアイテム',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -4 },
    priority: '高',
    estimatedHours: 3,
    notes: '招待状のデザインと文面を検討し、発注準備。',
    order: 12,
    isActive: true
  },
  {
    templateId: 'preset-013',
    name: '招待状発送',
    description: '招待状の印刷・宛名書き・発送',
    category: '招待状・ペーパーアイテム',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '最高',
    estimatedHours: 4,
    notes: '招待状の印刷・宛名書き・発送。',
    order: 13,
    isActive: true
  },
  {
    templateId: 'preset-014',
    name: '席次表・席札作成',
    description: '出席者確定後、席次表と席札を作成',
    category: '招待状・ペーパーアイテム',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -1 },
    priority: '高',
    estimatedHours: 3,
    notes: '出席者確定後、席次表と席札を作成。',
    order: 14,
    isActive: true
  },

  // 料理・ケーキ関連（挙式6ヶ月前～）
  {
    templateId: 'preset-015',
    name: '料理・ドリンクメニュー決定',
    description: '式場での料理・ドリンクの試食・選定',
    category: '料理・ケーキ',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -6 },
    priority: '高',
    estimatedHours: 3,
    notes: '式場での料理・ドリンクの試食・選定。',
    order: 15,
    isActive: true
  },
  {
    templateId: 'preset-016',
    name: 'ウェディングケーキ検討',
    description: 'ケーキのデザイン・味の選定',
    category: '料理・ケーキ',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -4 },
    priority: '中',
    estimatedHours: 2,
    notes: 'ケーキのデザイン・味の選定。',
    order: 16,
    isActive: true
  },

  // 装花・演出関連（挙式4ヶ月前～）
  {
    templateId: 'preset-017',
    name: '装花・会場装飾検討',
    description: 'ブーケ、会場装花のデザイン検討',
    category: '装花・演出',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -4 },
    priority: '中',
    estimatedHours: 2,
    notes: 'ブーケ、会場装花のデザイン検討。',
    order: 17,
    isActive: true
  },
  {
    templateId: 'preset-018',
    name: '演出プログラム検討',
    description: '挙式・披露宴での演出内容を検討',
    category: '装花・演出',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '中',
    estimatedHours: 3,
    notes: '挙式・披露宴での演出内容を検討。',
    order: 18,
    isActive: true
  },

  // 写真・映像関連（挙式6ヶ月前～）
  {
    templateId: 'preset-019',
    name: 'カメラマン・映像業者選定',
    description: '写真・映像撮影の業者選定と契約',
    category: '写真・映像',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -6 },
    priority: '高',
    estimatedHours: 4,
    notes: '写真・映像撮影の業者選定と契約。',
    order: 19,
    isActive: true
  },

  // 音楽・BGM関連（挙式3ヶ月前～）
  {
    templateId: 'preset-020',
    name: 'BGM・演奏曲選定',
    description: '挙式・披露宴で使用する音楽の選定',
    category: '音楽・BGM',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '中',
    estimatedHours: 2,
    notes: '挙式・披露宴で使用する音楽の選定。',
    order: 20,
    isActive: true
  },

  // 引き出物・プチギフト関連（挙式2ヶ月前～）
  {
    templateId: 'preset-021',
    name: '引き出物・プチギフト選定',
    description: 'ゲストへの引き出物とプチギフトの選定・発注',
    category: '引き出物・プチギフト',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '高',
    estimatedHours: 3,
    notes: 'ゲストへの引き出物とプチギフトの選定・発注。',
    order: 21,
    isActive: true
  },

  // 交通・宿泊関連（挙式3ヶ月前～）
  {
    templateId: 'preset-022',
    name: 'ゲストの交通・宿泊手配確認',
    description: '遠方ゲストの交通・宿泊手配の確認・案内',
    category: '交通・宿泊',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '中',
    estimatedHours: 2,
    notes: '遠方ゲストの交通・宿泊手配の確認・案内。',
    order: 22,
    isActive: true
  },

  // 法的手続き・事務関連（挙式1ヶ月前～）
  {
    templateId: 'preset-023',
    name: '婚姻届提出準備',
    description: '婚姻届の記入・証人確保・提出準備',
    category: '法的手続き・事務',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -1 },
    priority: '高',
    estimatedHours: 2,
    notes: '婚姻届の記入・証人確保・提出準備。',
    order: 23,
    isActive: true
  },
  {
    templateId: 'preset-024',
    name: '住所変更等の手続き確認',
    description: '結婚後の各種手続き（住所変更、名義変更等）の確認',
    category: '法的手続き・事務',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -1 },
    priority: '中',
    estimatedHours: 1,
    notes: '結婚後の各種手続き（住所変更、名義変更等）の確認。',
    order: 24,
    isActive: true
  },

  // 最終確認・その他（挙式2週間前～）
  {
    templateId: 'preset-025',
    name: '最終打ち合わせ（式場）',
    description: '式場との最終確認・当日の流れの確認',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -14 },
    priority: '最高',
    estimatedHours: 3,
    notes: '式場との最終確認・当日の流れの確認。',
    order: 25,
    isActive: true
  },
  {
    templateId: 'preset-026',
    name: '持ち物・当日準備リスト作成',
    description: '当日の持ち物や準備事項のチェックリスト作成',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -7 },
    priority: '高',
    estimatedHours: 1,
    notes: '当日の持ち物や準備事項のチェックリスト作成。',
    order: 26,
    isActive: true
  },

  // 【新規追加】デジタル効率化関連（挙式6ヶ月前～）
  {
    templateId: 'preset-027',
    name: '予算管理スプレッドシート作成',
    description: 'Googleスプレッドシートで予算管理システムを構築',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -6 },
    priority: '高',
    estimatedHours: 2,
    notes: 'Excelまたは Google Sheetsで項目別予算追跡表を作成。',
    order: 27,
    isActive: true
  },
  {
    templateId: 'preset-028',
    name: '結婚式準備LINEグループ作成',
    description: '家族・業者との連絡用LINEグループを作成',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -5 },
    priority: '中',
    estimatedHours: 1,
    notes: '効率的な情報共有のためのデジタル連絡網を構築。',
    order: 28,
    isActive: true
  },
  {
    templateId: 'preset-029',
    name: 'ゲスト住所収集Googleフォーム作成',
    description: 'オンラインで効率的に住所を収集',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -4 },
    priority: '高',
    estimatedHours: 1,
    notes: 'Google FormやTypeformで住所・アレルギー情報等を一括収集。',
    order: 29,
    isActive: true
  },
  {
    templateId: 'preset-030',
    name: 'QRコード付き招待状作成',
    description: 'デジタル招待状で効率的な返信システム構築',
    category: '招待状・ペーパーアイテム',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '中',
    estimatedHours: 2,
    notes: 'QRコードで出欠確認・アレルギー情報収集を効率化。',
    order: 30,
    isActive: true
  },
  {
    templateId: 'preset-031',
    name: 'デジタル写真共有システム準備',
    description: 'Google PhotosやDropboxで写真共有準備',
    category: '写真・映像',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 1,
    notes: 'ゲスト用写真共有アルバムの準備。リアルタイム共有設定。',
    order: 31,
    isActive: true
  },

  // 【新規追加】管理強化関連（挙式5ヶ月前～）
  {
    templateId: 'preset-032',
    name: '会場見積もり比較表作成',
    description: '複数会場の詳細比較表を作成',
    category: '式場・会場',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -5 },
    priority: '高',
    estimatedHours: 3,
    notes: '項目別の詳細比較で最適な会場選択をサポート。',
    order: 32,
    isActive: true
  },
  {
    templateId: 'preset-033',
    name: 'ゲストアレルギー・食事制限管理',
    description: 'アレルギー情報の詳細管理システム構築',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '高',
    estimatedHours: 2,
    notes: 'アレルギー・ベジタリアン・宗教的制限等の詳細管理。',
    order: 33,
    isActive: true
  },
  {
    templateId: 'preset-034',
    name: 'アクセサリー・小物選定',
    description: 'ブライダルアクセサリー・小物の選定',
    category: '衣装・美容',
    recommendedAssignee: '新婦',
    dueDateOffset: { unit: 'months', value: -3 },
    priority: '中',
    estimatedHours: 2,
    notes: 'ティアラ・ネックレス・イヤリング・ベール等の選定。',
    order: 34,
    isActive: true
  },
  {
    templateId: 'preset-035',
    name: 'ウェルカムボード・装飾品準備',
    description: 'オリジナルウェルカムボード・装飾品の制作',
    category: '装花・演出',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 4,
    notes: 'ハンドメイドまたは業者発注でオリジナル装飾品を準備。',
    order: 35,
    isActive: true
  },
  {
    templateId: 'preset-036',
    name: 'プロフィールムービー制作',
    description: '新郎新婦の紹介ムービー制作',
    category: '写真・映像',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 6,
    notes: '生い立ちから馴れ初めまでの映像作品制作。',
    order: 36,
    isActive: true
  },
  {
    templateId: 'preset-037',
    name: '交通アクセス・駐車場案内準備',
    description: '詳細なアクセス情報とマップ作成',
    category: '交通・宿泊',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 2,
    notes: 'バス・電車・車でのアクセス方法と駐車場情報の詳細案内。',
    order: 37,
    isActive: true
  },

  // 【新規追加】リスク管理関連（挙式1ヶ月前～）
  {
    templateId: 'preset-038',
    name: '当日タイムライン詳細作成',
    description: '15分刻みの詳細スケジュール作成',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -1 },
    priority: '最高',
    estimatedHours: 3,
    notes: '当日の分刻みスケジュールと関係者の役割分担。',
    order: 38,
    isActive: true
  },
  {
    templateId: 'preset-039',
    name: '緊急連絡先リスト作成',
    description: '当日の緊急時連絡先一覧作成',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -21 },
    priority: '高',
    estimatedHours: 1,
    notes: '式場・業者・医療機関等の緊急連絡先を整理。',
    order: 39,
    isActive: true
  },
  {
    templateId: 'preset-040',
    name: '悪天候・プランB準備',
    description: '屋外演出の代替案・悪天候対策準備',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -14 },
    priority: '中',
    estimatedHours: 2,
    notes: 'ガーデン挙式・屋外撮影等の悪天候代替プラン。',
    order: 40,
    isActive: true
  },
  {
    templateId: 'preset-041',
    name: '音響・照明リハーサル',
    description: '音響設備・照明演出の事前確認',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -7 },
    priority: '高',
    estimatedHours: 2,
    notes: 'BGM・スポットライト・マイク等の動作確認。',
    order: 41,
    isActive: true
  },

  // 【新規追加】挙式後準備関連（挙式2ヶ月前～）
  {
    templateId: 'preset-042',
    name: '新婚旅行詳細プラン作成',
    description: 'ハネムーンの詳細計画とブッキング',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 4,
    notes: '行程・宿泊・アクティビティの詳細プランニング。',
    order: 42,
    isActive: true
  },
  {
    templateId: 'preset-043',
    name: '新居・家電準備',
    description: '新生活に向けた住居・家電の準備',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'months', value: -2 },
    priority: '中',
    estimatedHours: 5,
    notes: '新居探し・引越し・必要な家電・家具の選定。',
    order: 43,
    isActive: true
  },
  {
    templateId: 'preset-044',
    name: '結婚式写真・動画整理計画',
    description: '当日写真・動画の整理・保存方法の計画',
    category: '写真・映像',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -30 },
    priority: '低',
    estimatedHours: 2,
    notes: 'プロ撮影・ゲスト撮影写真の整理・共有方法を事前計画。',
    order: 44,
    isActive: true
  },
  {
    templateId: 'preset-045',
    name: '結婚報告・お礼状準備',
    description: '結婚報告はがき・お礼状の準備',
    category: 'その他',
    recommendedAssignee: '二人',
    dueDateOffset: { unit: 'days', value: -30 },
    priority: '低',
    estimatedHours: 2,
    notes: '結婚報告・年賀状・お礼状のデザイン・文面準備。',
    order: 45,
    isActive: true
  }
];

/**
 * 挙式日からの相対期限を計算する関数
 * @param weddingDate 挙式日（YYYY-MM-DD形式）
 * @param offset 期限オフセット
 * @returns 計算された期限日（YYYY-MM-DD形式）
 */
export function calculateDueDateFromOffset(
  weddingDate: string,
  offset: { unit: 'months' | 'days'; value: number }
): string {
  const wedding = new Date(weddingDate);
  const dueDate = new Date(wedding);

  if (offset.unit === 'months') {
    dueDate.setMonth(dueDate.getMonth() + offset.value);
  } else if (offset.unit === 'days') {
    dueDate.setDate(dueDate.getDate() + offset.value);
  }

  return dueDate.toISOString().split('T')[0]; // YYYY-MM-DD形式で返す
}

/**
 * プリセットタスクテンプレートから実際のタスクオブジェクトを生成
 * @param template プリセットタスクテンプレート
 * @param weddingDate 挙式日（YYYY-MM-DD形式）
 * @returns 生成されたタスクオブジェクト
 */
export function generateTaskFromTemplate(
  template: PresetTaskTemplate,
  weddingDate?: string
): Omit<import('../types').Task, 'id' | 'createdAt' | 'updatedAt'> {
  const now = Date.now();
  
  return {
    name: template.name,
    description: template.description,
    category: template.category,
    assignee: template.recommendedAssignee,
    status: '未着手',
    priority: template.priority,
    dueDate: weddingDate 
      ? calculateDueDateFromOffset(weddingDate, template.dueDateOffset)
      : '',
    estimatedHours: template.estimatedHours,
    notes: template.notes,
    isPreset: true,
    presetTemplateId: template.templateId,
    tags: ['プリセット']
  };
} 